import React from "react";
import PropTypes from "prop-types";

import LpgContinueSolid from "@/icons/Lpg/ContinueSolid";
import { Button } from "../Button";
import { Icon } from "../Icon";

import styles from "./ContentNavigation.scss";

// included iconWrapperProps since icon svg viewboxes are inconsitent,
// making proper alignment impossible without tweaks
function NavItem({ children, icon, iconWrapperProps, ...props }) {
  return (
    <div className={styles.navItemWrapper}>
      <Button variants={[Button.Variant.bare, styles.navItem]} {...props}>
        <span className={styles.contentIcon}>
          <Icon
            icon={icon}
            size={Icon.Size.parent}
            wrapperProps={iconWrapperProps}
          />
        </span>
        <span className={styles.label}>
          {children}
          <span className={styles.labelArrowIcon}>
            <Icon icon={LpgContinueSolid} size={Icon.Size.parent} />
          </span>
        </span>
      </Button>
    </div>
  );
}

NavItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  icon: PropTypes.elementType.isRequired,
  iconWrapperProps: PropTypes.shape({}),
};

NavItem.defaultProps = {
  iconWrapperProps: null,
};

NavItem.displayName = "ContentNavigation.Item";

export default NavItem;
